import React, { useRef } from "react"
import { useNavigate } from "react-router"

interface ClickableVideoProps {
    videoSrc: string
    link: string
    altText?: string
}

export function ClickableVideo({ videoSrc, link, altText = "Video" }: ClickableVideoProps): React.JSX.Element {
    const videoRef = useRef<HTMLVideoElement>(null)
    const navigate = useNavigate()

    const handleMouseEnter = (): void => {
        if (videoRef.current) {
            // This starts the video and therefor we do not want to wait for it
            void videoRef.current.play()
        }
    }

    const handleMouseLeave = (): void => {
        if (videoRef.current) {
            videoRef.current.pause()
            videoRef.current.currentTime = 0 // Reset video to start
        }
    }

    const handleClick = (): void => {
        navigate(link)  // Use React Router navigation instead of window.location.href
    }

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            style={{ cursor: "pointer", display: "inline-block" }}
        >
            <video ref={videoRef} width="320" height="240" muted>
                <source src={videoSrc} type="video/mp4" />
                {altText}
            </video>
        </div>
    )
}